export const columns = [
  {
    header: "City",
    accessorKey: "location_name",
  },
  {
    header: "District",
    accessorKey: "district_name",
    cell: ({ row }) => row.original.district_name || "—",
  },
  {
    header: "Fee (Rs.)",
    accessorKey: "fee",
  },
  {
    header: "Created At",
    accessorKey: "created_at",
  },
]
